import { BasketViewModel } from '@/api/checkout';
import { sessionStorageService } from '@/core/storage/storage.service';
import { basketKeys } from '@/project/basket/basket.service';
import router, { PageNames } from '@/router';
import { RedirectError } from '../HttpRedirectError';

const checkoutRoutes = [
    PageNames.GiftCardCheckoutReceipt,
];

export const basketStateHandler = (response) => {
    const basket: BasketViewModel = response.data?.model?.id ? response.data?.model : response.data?.basket?.model ?? null;

    const isNotInReceiptRoute = !checkoutRoutes.includes(router.currentRoute.value.name as PageNames);

    if (basket && basket.isCompleted && isNotInReceiptRoute) {
        sessionStorageService.removeItem(basketKeys.GiftCard);

        throw new RedirectError();
    }

    // During initial navigation currentRoute is START_LOCATION (name undefined,
    // matched empty). Route-dependent decisions must not run on unresolved
    // navigation state, so skip until the first navigation has resolved.
    const isInitialNavigationPending = router.currentRoute.value.matched.length === 0;

    if (isInitialNavigationPending ||
        router.currentRoute.value.name === PageNames.GiftCardCheckoutInformation ||
        router.currentRoute.value.name === PageNames.GiftCardCheckoutPayment ||
        router.currentRoute.value.name === PageNames.GiftCardCheckoutReceipt) {
        return response;
    }

    sessionStorageService.removeItem(basketKeys.GiftCard);

    return response;
};
